import type { ShiftProductionForm } from "../../../shared/shift-production-form/contracts";

/** Only the current submitted revision can be shown as pending; never show an editable draft. */
export function analysisSubmittedForm(form: ShiftProductionForm, revisionNumber: number | undefined): ShiftProductionForm | null {
  if (!form.currentApprovalStage || revisionNumber !== form.revisionNumber) return null;
  const revision = form.revisions.find(item => item.revisionNumber === revisionNumber);
  if (!revision) return null;
  return { ...form, payload: revision.snapshot, submittedSnapshot: revision.snapshot, submittedAt: revision.submittedAt, canDecide: false };
}
